import { t } from "i18next"
import LeadReviewForm from "../components/leadReviewForm"
import AuditReviewForm from "../components/auditReviewForm"

export const REVIEW_TYPE_CONFIG = () => [
  {
    key: "lead_review",
    label: t("Lead"),
    value: "lead_review",
    privilege: "can_add_lead_review",
    component: LeadReviewForm,
  },
  {
    key: "audit_review",
    value: "audit_review",
    label: t("Audit"),
    privilege: "can_add_audit_review",
    component: AuditReviewForm,
  },
]

export const interestOptions = () => [
  { label: t("Interested"), key: "interested", value: true },
  { label: t("Not Interested"), key: "notInterested", value: false },
]

export const interestOptionsFilter = () => [
  { label: t("Interested"), value: "true" },
  { label: t("Not Interested"), value: "false" },
]
